import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText
} from '@material-ui/core';
import RegisterButton from '../../components/atoms/RegisterButton';
import CancelButton from '../../components/atoms/CancelButton';

const styles = {
  dialogContent: {
    fontWeight: 700,
    fontSize: '16px',
    color: 'red'
  },
  checkBox: {
    padding: '0 8px 0 0'
  },
  checkLine: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 24,
    justifyContent: 'center'
  },
  header: {
    fontSize: 24,
    fontWeight: 700,
    lineHeight: '140%',
    textAlign: 'center'
  },
  body: {
    fontSize: 16,
    fontWeight: 400,
    marginTop: 16,
    lineHeight: '160%'
  },
  supportLink: {
    display: 'flex',
    alignItems: 'center',
    textDecorationLine: 'underline'
  },
  supportIcon: {
    marginLeft: '8px'
  },
  contentContainer: {
    padding: '48px 16px 12px !important'
  },
  buttonContainer: {
    padding: '0 16px 48px'
  },
  btnBtom: {
    padding: '0 16px 20px'
  }
};

const enhance = compose();

const useStyles = makeStyles({
  paperWidthSm: {
    maxWidth: 315
  }
});

const Main = enhance(({ classes, show, backAction, editAction, isSmall }) => {
  const classesD = useStyles();

  return (
    <Dialog
      open={show}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={isSmall ? 'sm' : false}
      classes={{
        paperWidthSm: classesD.paperWidthSm
      }}
    >
      <DialogContent className={classes.contentContainer}>
        <DialogContentText
          id="alert-dialog-description"
          className={classes.dialogContent}
        >
          <div>
            価格または税率が変更されています！
            <br />
            現在購入中の利用者がいた場合、価格に影響が出ます。
            <br />
            <br />
            店舗でのご利用が多い時間帯のご変更は避けてください。
            <br />
            <br />
            登録してもよろしいですか？
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.btnBtom}>
        <CancelButton onClickAction={backAction} />
        <RegisterButton onClickAction={editAction} />
      </DialogActions>
    </Dialog>
  );
});

export default withRouter(withStyles(styles)(Main));
